import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHeader, TableRow } from '../table';
import { Industry } from '../../stores/industryStore';

interface IndustryTableProps {
  industries: Industry[];
  onRowClick: (industry: Industry) => void;
}

const IndustryTable: React.FC<IndustryTableProps> = ({ industries, onRowClick }) => {
  const { t } = useTranslation(['admin', 'common', 'jobs']);

  return (
    <div className="max-w-full overflow-x-auto">
      <Table className="w-full">
        <TableHeader className="bg-gray-50 dark:bg-white/[0.05]">
          <TableRow>
            {['label', 'validated', 'created_at', 'deleted'].map(field => (
              <TableCell
                key={field}
                isHeader
                className="text-start px-6 py-4 font-semibold uppercase text-gray-600 text-[0.75rem] tracking-wide dark:text-gray-400"
              >
                {t(`table_fields.${field}`, { ns: 'admin' })}
              </TableCell>
            ))}
          </TableRow>
        </TableHeader>

        <TableBody className="divide-y divide-gray-100 dark:divide-white/[0.05]">
          {industries.map(industry => (
            <TableRow
              key={industry.id}
              onClick={() => onRowClick(industry)}
              className="cursor-pointer transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-white/[0.08]"
            >
              <TableCell className="px-6 py-4">
                {t(`industries.${industry.slug}`, { ns: 'common', defaultValue: industry.label })}
              </TableCell>

              <TableCell className="px-6 py-4 text-gray-600 dark:text-gray-400 text-sm">
                {industry.validated
                  ? t('form_fields.yes', { ns: 'common', defaultValue: 'Oui' })
                  : t('form_fields.no', { ns: 'common', defaultValue: 'Non' })}
              </TableCell>

              <TableCell className="px-6 py-4 text-gray-600 dark:text-gray-400 text-sm">
                {industry.created_at ? new Date(industry.created_at).toLocaleDateString() : '-'}
              </TableCell>

              <TableCell className="px-6 py-4 text-gray-600 dark:text-gray-400 text-sm">
                {industry.deleted
                  ? t('form_fields.yes', { ns: 'common', defaultValue: 'Oui' })
                  : t('form_fields.no', { ns: 'common', defaultValue: 'Non' })}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default IndustryTable;
